import React, { useEffect, useState, useRef } from "react";
import Swiper from "react-id-swiper";
import "swiper/css/swiper.css";
import axios from "axios";
import { Constant, imageDomain } from "../helper/Constants";
import DemoBookingModal from "./common/DemoBookingModal";

const HeroSlider = () => {
  const [allBanners, setAllBanners] = useState([]);
  const modalRef = useRef(null);

  useEffect(() => {
    getBannerImages();
  }, []);

  const getBannerImages = async () => {
    try {
      const resp = await axios.get(Constant.getUrls.getAllBanners);
      const banners = (resp?.data?.data || []).map((item) => ({
        id: item._id,
        backgroundImage: imageDomain + item.banner_image,
        title: item.banner_title,
      }));
      setAllBanners(banners);
    } catch (err) {
      console.error("Banner Fetch Error", err);
    }
  };

  const sliderSettings = {
    slidesPerView: 1,
    loop: true,
    speed: 1200,
    autoplay: { delay: 2500, disableOnInteraction: false },
    shouldSwiperUpdate: true,
    rebuildOnUpdate: true,
  };

  // use the modal ref to open it reliably
  const openDemoModal = (prefill = {}) => {
    if (modalRef.current && typeof modalRef.current.open === "function") {
      modalRef.current.open(prefill);
      return;
    }
    // fallback to global helper if ref isn't ready
    if (typeof window.openDemoModal === "function") {
      window.openDemoModal(prefill);
    } else {
      console.warn("Demo modal not available yet");
    }
  };

  return (
    <>
      {/* ensure modal is mounted - pass ref */}
      <DemoBookingModal ref={modalRef} />

      <section
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "60px 8%",
          background: "linear-gradient(to right, #29166e 0%, #ffffff 100%)",
          gap: "40px",
          flexWrap: "wrap",
          height: "70vh",
        }}
      >
        {/* LEFT SECTION */}
        <div style={{ flex: 1, minWidth: "300px" }}>
          <h3
            style={{ color: "#ff6f6f", fontSize: "22px", marginBottom: "10px" }}
          >
            Make Your Child
          </h3>

          <h1
            style={{
              fontSize: "48px",
              fontWeight: "700",
              lineHeight: "1.2",
              color: "#fff",
            }}
          >
            <span
              style={{
                background: "#ff6f6f",
                color: "#fff",
                padding: "4px 12px",
                borderRadius: "5px",
                marginRight: "8px",
              }}
            >
              MATH
            </span>
            GENIUS
          </h1>

          <p style={{ marginTop: "15px", fontSize: "18px", color: "#fff" }}>
            With VASA-ABACUS
          </p>

          <button
            onClick={() => openDemoModal()}
            style={{
              marginTop: "25px",
              background: "#ff6f6f",
              color: "#fff",
              padding: "14px 28px",
              border: "none",
              borderRadius: "6px",
              fontSize: "16px",
              cursor: "pointer",
            }}
          >
            Book A Free Demo Class
          </button>

          <p style={{ marginTop: "20px", fontSize: "16px", color: "#fff" }}>
            Offline / Online Classes Available
          </p>
        </div>

        {/* RIGHT SECTION — DYNAMIC RECTANGULAR SLIDER */}
        <div style={{ flex: 1, minWidth: "300px" }}>
          <Swiper {...sliderSettings}>
            {allBanners.map((banner, index) => (
              <div key={index}>
                <p
                  style={{
                    fontSize: "24px",
                    color: "#ff6f6f",
                    marginTop: "12px",
                    fontWeight: "600",
                    textAlign: "center",
                  }}
                >
                  {banner.title || "Empowering Young Minds Worldwide"}
                </p>
                <div
                  style={{
                    width: "100%",
                    height: "300px",
                    overflow: "hidden",
                    borderRadius: "12px",
                  }}
                >
                  <img
                    src={banner.backgroundImage}
                    alt={`slide-${index}`}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </div>
            ))}
          </Swiper>
        </div>
      </section>

      {/* Fixed bottom-right demo button — opens the modal */}
      <button
        onClick={() => openDemoModal()}
        aria-label="Book A Demo Call"
        style={{
          position: "fixed",
          right: 20,
          bottom: 80,
          zIndex: 9999,
          background: "#ff6f6f",
          color: "#fff",
          padding: "18px 32px",
          borderRadius: 12,
          fontWeight: 700,
          fontSize: "18px",
          textDecoration: "none",
          boxShadow: "0 10px 28px rgba(0,0,0,0.18)",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          border: "none",
        }}
      >
        Book A Demo Call
      </button>
    </>
  );
};

export default HeroSlider;
